import React, { createContext, useState } from "react";

// Context State
interface SpecialContentContextState {
  xmasSpecialDialogOpen: boolean;
  updateXmasSpecialDialogOpen: (b: boolean) => void;
}

// Context
export const SpecialContentContext = createContext<SpecialContentContextState>({
  xmasSpecialDialogOpen: false,
  updateXmasSpecialDialogOpen: () => {},
});

// Context Provider
const SpecialContentContextProvider = (props: { children: JSX.Element | JSX.Element[] }) => {
  const [xmasSpecialDialogOpen, setXmasSpecialDialogOpen] = useState(false);

  const updateXmasSpecialDialogOpen = (b: boolean) => {
    setXmasSpecialDialogOpen(b);
  };

  const { children } = props;

  return (
    <SpecialContentContext.Provider
      value={{
        xmasSpecialDialogOpen,
        updateXmasSpecialDialogOpen,
      }}
    >
      {children}
    </SpecialContentContext.Provider>
  );
};

export default SpecialContentContextProvider;
